import HighchartsReact from "highcharts-react-official"
import Highcharts from 'highcharts'
import { Spinner } from "reactstrap";
import { connect } from "react-redux";

const PieChart = ({ useQuery, params, selectedCurrency }) => {
  const { data, isFetching } = useQuery(
    ...params
  );

  const chartOptions = () => {
    return {
      credits: { enabled: false },
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        height: 300,
      },
      title: {
        text: ''
      },
      tooltip: {
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true,
          outline: {
            enabled: false
          }
        }
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          borderColor: 'transparent',
          data: data?.map?.(item => ({
            ...item,
            y: (item.y && !isNaN(item.y)) ? Math.round(item.y * (selectedCurrency?.value || 1)) : item.y || 0
          })) || data,
        }
      ]
    }
  }
  return (
    <>
      {isFetching && <Spinner />}
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions()}
      />
    </>
  );
}

const mapStateToProps = state => ({
  selectedCurrency: state.currency.selectedCurrency,
});

export default connect(mapStateToProps)(PieChart);
